import { Link2, Mail } from 'lucide-react';

interface InviteDrawerFooterProps {
  canSubmit: boolean;
  isLink: boolean;
  /** Swaps the send button for one that links an existing login. */
  confirmLinkExisting: boolean;
  submitting: boolean;
  done: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

function submitLabel(submitting: boolean, isLink: boolean, confirmLinkExisting: boolean): string {
  if (submitting) return 'Sending…';
  if (confirmLinkExisting) return 'Link existing account';
  return isLink ? 'Link & send invite' : 'Send invite';
}

/** The Cancel and Send row at the bottom of the invite drawer. */
export default function InviteDrawerFooter({
  canSubmit,
  isLink,
  confirmLinkExisting,
  submitting,
  done,
  onCancel,
  onSubmit,
}: InviteDrawerFooterProps) {
  return (
    <div className="px-6 py-3.5 border-t border-stone-200 dark:border-stone-800 bg-stone-50 dark:bg-[#1e2520] flex items-center gap-2.5">
      <div className="flex-1 text-[11px] text-stone-500 dark:text-stone-400 leading-snug">
        Audit event will record the inviter.
      </div>
      <button
        type="button"
        onClick={onCancel}
        className="h-8 px-3.5 rounded-lg text-[13px] font-semibold text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28]"
      >
        {done ? 'Close' : 'Cancel'}
      </button>
      {!done && (
        <button
          type="button"
          onClick={onSubmit}
          disabled={!canSubmit}
          className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-lg text-[13px] font-semibold text-white bg-moss-600 hover:bg-moss-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLink || confirmLinkExisting ? <Link2 size={13} /> : <Mail size={13} />}
          {submitLabel(submitting, isLink, confirmLinkExisting)}
        </button>
      )}
    </div>
  );
}
